import { render, staticRenderFns } from "./rx-disclaimer-widget.vue?vue&type=template&id=210fb97f&scoped=true"
import script from "./rx-disclaimer-widget.vue?vue&type=script&lang=js"
export * from "./rx-disclaimer-widget.vue?vue&type=script&lang=js"
import style0 from "./rx-disclaimer-widget.vue?vue&type=style&index=0&id=210fb97f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210fb97f",
  null
  
)

export default component.exports